import React from 'react';
import Seo from '../../components/Seo';

function PoliticaEditorial() {
  return (
    <div className="page page--narrow">
      <Seo title="Política editorial" />
      <h1>Política editorial</h1>
      <p>
        Independencia, transparencia y honestidad son los principios de Libros para Viajeros. Las colaboraciones
        remuneradas compensan el tiempo de lectura, análisis, producción, edición y difusión del contenido. La
        contratación de una colaboración no garantiza una valoración positiva ni condiciona la opinión publicada.
      </p>
      <p>Toda colaboración se identifica claramente en el contenido en el que aparece.</p>
    </div>
  );
}

export default PoliticaEditorial;
